
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"28","cy":"28","r":"12","fill":"#E8E8E8"}}),_c('circle',{attrs:{"cx":"28","cy":"6","r":"6","fill":"#3084B9"}}),_c('circle',{attrs:{"cx":"12","cy":"44","r":"6","fill":"#E8E8E8"}}),_c('circle',{attrs:{"cx":"44","cy":"12","r":"6","fill":"#E8E8E8"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"6","fill":"#E8E8E8"}}),_c('circle',{attrs:{"cx":"44","cy":"44","r":"6","fill":"#E8E8E8"}}),_c('circle',{attrs:{"cx":"28","cy":"50","r":"6","fill":"#E8E8E8"}}),_c('circle',{attrs:{"cx":"50","cy":"28","r":"6","fill":"#E8E8E8"}}),_c('circle',{attrs:{"cx":"6","cy":"28","r":"6","fill":"#E8E8E8"}})])
          )
        }
      }
    